module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "grid grid-cols-12 mt-8"
  }, [_c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2 mb-2"
  }, [_vm._v("\n        Biblioteca (" + _vm._s(_vm.filteredLibraries.length) + ")\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre..."
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-12 xxl:col-span-12 mb-4"
  }, [_c('p', {
    staticClass: "w-full"
  }, [_vm._v("Filtrar por cualquiera de las siguientes categorias:")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 flex flex-wrap"
  }, [_c('button', {
    staticClass: "button border-theme-5 border flex mr-1 mb-2",
    class: {
      'bg-theme-1 text-white': _vm.filter.category == null
    },
    on: {
      "click": function($event) {
        return _vm.setCategory(null)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "layers",
      "classname": "w-4 h-4 mr-2 mt-1"
    }
  }), _vm._v("\n            Todas las categorias\n          ")], 1), _vm._v(" "), _vm._l((_vm.filteredCategories), function(categoryMenu) {
    return _c('button', {
      key: ("category-" + (categoryMenu.name)),
      staticClass: "button border-theme-5 border flex mr-1 mb-2",
      class: {
        'bg-theme-1 text-white': categoryMenu.name == _vm.filter.category
      },
      on: {
        "click": function($event) {
          return _vm.setCategory(categoryMenu.name)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": categoryMenu.icon ? categoryMenu.icon : 'file',
        "classname": "w-4 h-4 mr-2 mt-1"
      }
    }), _vm._v("\n            " + _vm._s(categoryMenu.name) + "\n          ")], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-12 xxl:col-span-12 mb-4"
  }, [_c('p', {
    staticClass: "w-full"
  }, [_vm._v("Filtrar por cualquiera de los siguientes equipos:")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 flex flex-wrap"
  }, [_c('button', {
    staticClass: "button border-theme-5 border flex mr-1 mb-2",
    class: {
      'bg-theme-1 text-white': _vm.filter.team == null
    },
    on: {
      "click": function($event) {
        return _vm.setTeam(null)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "layers",
      "classname": "w-4 h-4 mr-2 mt-1"
    }
  }), _vm._v("\n            Todos los equipos\n          ")], 1), _vm._v(" "), _vm._l((_vm.teams), function(teamMenu) {
    return _c('button', {
      key: ("team-" + (teamMenu.name)),
      staticClass: "button border-theme-5 border flex mr-1 mb-2",
      class: {
        'bg-theme-1 text-white': teamMenu.id == _vm.filter.team
      },
      on: {
        "click": function($event) {
          return _vm.setTeam(teamMenu.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(teamMenu.name) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12"
  }, _vm._l((_vm.filteredLibraries), function(library) {
    return _c('div', {
      key: ("library-" + (library.slug)),
      staticClass: "intro-y col-span-12 sm:col-span-12 md:col-span-4 xxl:col-span-4 mr-2 mb-2"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": library.url
      }
    }, [_c('div', {
      staticClass: "box h-full zoom-in"
    }, [_c('div', {
      staticClass: "rounded-md px-5 py-4 mb-2"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "font-medium text-lg"
    }, [_vm._v(_vm._s(library.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-xs bg-gray-600 px-1 rounded-md text-white ml-auto"
    }, [_vm._v(_vm._s(library.category))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 mb-2"
    }, [_vm._v("\n                " + _vm._s(library.description) + "\n              ")]), _vm._v(" "), (library.url) ? _c('div', {
      staticClass: "text-theme-1 hidden text-right font-bold"
    }, [_vm._v("\n                Da clic para abrir\n              ")]) : _vm._e()])])])])
  }), 0)]) : _c('app-loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de885d56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/library/LibraryTeam.vue
// module id = 479
// module chunks = 1